import { useMemo } from 'react'
import type { TabMappings } from '@/views/PreSales/PreSalesGiveawayView/components/Tabs/GiveawayTabs/types'
import { GiveawayTabEnum } from '@/views/PreSales/PreSalesGiveawayView/config'

interface TabRefs {
  detailsContainerRef: React.RefObject<HTMLDivElement>
  faqContainerRef: React.RefObject<HTMLDivElement>
  prizesContainerRef: React.RefObject<HTMLDivElement>
}

interface TabScrolls {
  scrollToDetails: () => void
  scrollToFaq: () => void
  scrollToPrizes: () => void
}

export const useTabMappings = (refs: TabRefs, scrolls: TabScrolls): TabMappings =>
  useMemo(
    () => ({
      refs: {
        [GiveawayTabEnum.Details]: refs.detailsContainerRef,
        [GiveawayTabEnum.Faq]: refs.faqContainerRef,
        [GiveawayTabEnum.Prizes]: refs.prizesContainerRef,
      },
      scrolls: {
        [GiveawayTabEnum.Details]: scrolls.scrollToDetails,
        [GiveawayTabEnum.Faq]: scrolls.scrollToFaq,
        [GiveawayTabEnum.Prizes]: scrolls.scrollToPrizes,
      },
    }),
    [
      refs.detailsContainerRef,
      refs.faqContainerRef,
      refs.prizesContainerRef,
      scrolls.scrollToDetails,
      scrolls.scrollToFaq,
      scrolls.scrollToPrizes,
    ],
  )
